import { Box, Typography, useTheme } from '@mui/material';

export const VerifySuccess = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        minHeight: '70vh',
        py: '40px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
      }}
    >
      <i
        className="fa-light fa-envelope-circle-check"
        style={{ color: theme.palette.success.main, fontSize: '96px' }}
      />
      <Typography variant="h1" sx={{ mt: 4 }}>
        Congratulations!
      </Typography>
      <Typography variant="h4" sx={{ mt: 2 }}>
        Your email address has been successfully verified.
      </Typography>
    </Box>
  );
};
